import axios from "axios";

axios.defaults.baseURL = process.env.REACT_SERVER_BASE_URL_LOCAL

export const axiosAPI = axios.create({
    baseURL: process.env.REACT_SERVER_BASE_URL_LOCAL,
})

// Returns a nice string by reading the axios error.
export function parseAxiosError(err: any): string {
    let message = null;
    if (!message) message = err?.response?.data?.error?.error;
    if (!message) message = err;
    else message = capitalizeFirstLetter(message);
    return message + "";
}

function capitalizeFirstLetter(s: string): string {
    return s.charAt(0).toUpperCase() + s.slice(1);
}